import { Icon } from "components";
import { useSidebar } from "ui/components/sidebar";
import { cn } from "utils";

// Sidebar header with just the integration logo, sized like the project header
// logo: full sidebar width when expanded, small when collapsed.
export default function IntegrationIconHeader({ icon, title }) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  return (
    <div className="flex flex-col gap-2 p-4" title={title}>
      <div
        className={cn(
          "aspect-square transition-all duration-200 flex items-center justify-center",
          isCollapsed ? "size-6" : "size-44",
        )}
      >
        <Icon icon={icon} className="size-full" />
      </div>
    </div>
  );
}
